'use client';

import { BaseTranslations } from '../../../../baseTranslations';
import { MaterialIcon } from '../../../../components/MaterialIcon';
import { useCmsClientContext } from '../../../../utils/cmsPageContext';
import { getClientTranslations } from '../../../../utils/translations/getClientTranslations';
import { tr } from '../../../../utils/translations/tr';
import { ProductDetailsSectionHeader } from '../../BaseComponents/ProductDetailsSectionHeader';

/** Shared "Eligibility" section header (icon + translated title) used by every eligibility variant. */
export const EligibilitySectionHeader: React.FC = () => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(BaseTranslations, context);

  return (
    <ProductDetailsSectionHeader
      icon={<MaterialIcon icon="new_releases" size={3} />}
    >
      {tr('pd_nav_eligibility', staticText)}
    </ProductDetailsSectionHeader>
  );
};
